/** @jsxImportSource theme-ui */
import DesktopSplash from 'assets/insights-splash-desktop.png';
import MobileSplash from 'assets/insights-splash-mobile.png';

import { sxtheme } from '../../utils/cssHelpers';
import { Typography } from '../_common/Typography';
import InsightsLogo from './InsightsLogo';

const Splash = () => {
  return (
    <div
      sx={{
        position: 'relative',
        minHeight: ['0', '700px'],
        height: '100%',
        width: '100%',
        backgroundColor: sxtheme(t => t.colors.seaweed30),
      }}
    >
      <div
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          width: '100%',
          height: '35%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <InsightsLogo
          styles={{
            visibility: ['visible', 'hidden'],
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            paddingTop: '2rem',
          }}
        />
        <Typography
          variant="h4"
          color="deepSea90"
          sx={{
            display: 'block',
            margin: 'auto',
            textAlign: 'center',
            maxWidth: ['20rem', '29rem'],
            fontSize: ['1.5rem', '2.25rem'],
            lineHeight: ['1.75rem', '2.5rem'],
          }}
        >
          Near real-time disease alerts based on your location.
        </Typography>
      </div>
      <div
        sx={{
          height: '100%',
          width: '100%',
          backgroundImage: [`url('${MobileSplash}')`, `url('${DesktopSplash}')`],
          backgroundSize: ['contain', 'cover'],
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        }}
      />
    </div>
  );
};

export default Splash;
